"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.common = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var common = {
  intent: _propTypes["default"].oneOf(['primary', 'positive', 'negative']),
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  alignment: _propTypes["default"].exact({
    vertical: _propTypes["default"].oneOf(['start', 'end', 'center', 'stretch', 'space-between', 'space-around']),
    horizontal: _propTypes["default"].oneOf(['start', 'end', 'center', 'stretch', 'space-between', 'space-around'])
  }),
  direction: _propTypes["default"].oneOf(['row', 'column']),
  text: _propTypes["default"].oneOf(['span', 'code', 'small', 'body', 'article', 'caption', 'h6', 'h5', 'h4', 'h3', 'h2', 'h1']),
  position: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
  indentSize: _propTypes["default"].oneOf(['small', 'medium', 'regular', 'large']),
  wrapperTag: _propTypes["default"].oneOf(['div', 'header', 'footer', 'main', 'aside', 'section', 'nav'])
};
exports.common = common;